import React from 'react';
import PropTypes from 'prop-types';
import Option from '../MultipleChoice/Option';
import classNames from 'classnames';
import './styles.styl';

const WordBankSelect = ({
  data,
  onClick,
  input,
  correctInput,
  validationResult,
  isFinalAttempt
}) => {
  const hasValidated = validationResult !== null;

  const getFeedback = option => {
    if (hasValidated && correctInput) {
      const isCorrectOption = correctInput === option;
      return isCorrectOption ? 'success' : 'error';
    }
  };

  const isChecked = option => {
    return input === option;
  };

  const handleClick = option => {
    onClick(`${data.beforeSpace}${data.afterSpace}`, option);
  };

  const spaceClasses = () => {
    return classNames(
      {
        'wbs__question__space--occupied': input
      },
      'wbs__question__space'
    );
  };

  return (
    <div className="multiple-choice__question">
      {'image' in data && (
        <div className="multiple-choice__question__image-wrapper">
          <img alt={data.imageText} src={data.image} width="350" />
        </div>
      )}
      <h3 className="wbs__question">
        {data.beforeSpace}
        <span className={spaceClasses()}>{input}</span>
        {data.afterSpace}
      </h3>
      <div className="wbs__option-container">
        {data.options.map((option, i) => {
          return (
            <div key={i} className="wbs__option-wrapper">
              <Option
                key={i}
                type="radio"
                data={option}
                question={`${data.beforeSpace}${data.afterSpace}`}
                onClick={handleClick}
                checked={isChecked(option.label)}
                readOnly={hasValidated}
                feedback={getFeedback(option.label)}
                isFinalAttempt={isFinalAttempt}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

WordBankSelect.propTypes = {
  data: PropTypes.object.isRequired
};

export default WordBankSelect;



// WEBPACK FOOTER //
// ../core/src/components/WordBankSelect/WordBankSelect.js